export default {"src":"/_next/static/media/link.1d54f795.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};